module.exports = __webpack_public_path__ + "static/triberMotion-c32e6c654cfea6d284e6dffb6ebdf261.gif";